import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';
import dayjs from 'dayjs';
import PerButton from '../../Permit/ui/PerButton';
import { Swiper, SwiperSlide } from 'swiper/react';
import PinchZoom from '../../../Components/Ui/PinchZoom';
import Global from '../../../Services/Common/Global';
import { Pagination } from 'swiper/modules';
import { useOutletContext } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import SignWorkStopBottomStheet from '../ui/SignWorkStopBottomStheet';
import usePhoneCall from '../../../Hooks/useCallHandler';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import Commons from '../../../Services/Common/Common';
import {
  getWriterRoleLabel,
  getWriterPerson,
  getWorkStopNoticeMessage,
  hasUserResumeApprovalYn,
  isEmtUser,
} from '../ui/workStopUtils';
import WorkStopRecipientSection from '../ui/WorkStopRecipientSection';
import WorkStopPersonInfo from '../ui/WorkStopPersonInfo';
import { Button } from '../../../Components/MUIs';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';

export default function M_WOS_BASIC_02(props) {
  const { navigate } = useAppNavigate();
  const outletContext = useOutletContext();
  const ToggleDrawer =
    props.ToggleDrawer ?? outletContext?.ToggleDrawer ?? (() => () => {});
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const [showButton, setShowButton] = useState(false);
  const [saveText, setSaveText] = useState('작업 재개 승인');
  const [stopIndex, setStopIndex] = useState(0);
  const [solveIndex, setSolveIndex] = useState(0);

  const { gubun, updateId } = props.rowData1;

  const { handleCall } = usePhoneCall();
  const stopNoticeMessage =
    gubun === '중지' ? getWorkStopNoticeMessage(props.rowData1) : null;
  const canResumeApprove = hasUserResumeApprovalYn(userInfo);

  useEffect(() => {
    if (!gubun) return;

    const isCurrentUserUpdateId = updateId === userInfo?.decUserId;
    const emtUser = isEmtUser(userInfo);

    if (gubun === '승인') {
      setShowButton(false);
    } else if (gubun === '미해결') {
      setShowButton(emtUser && isCurrentUserUpdateId);
      setSaveText('수정');
    } else {
      setShowButton(emtUser);
      setSaveText('작업 재개 승인');
    }
  }, [gubun, updateId, userInfo]);

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box>
        <Box sx={{ fontSize: '16px', color: '#918A8A', lineHeight: 1.6 }}>
          {gubun === '중지' ? (
            <>
              <Box
                component="p"
                sx={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#3A3A3A',
                  mb: 1,
                }}
              >
                {stopNoticeMessage.title}
              </Box>
              <Box component="p" sx={{ m: 0 }}>
                {stopNoticeMessage.description}
              </Box>
            </>
          ) : (
            <>
              <span
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#3A3A3A',
                }}
              >
                {props.rowData1?.gubun === '승인'
                  ? '작업 재개를 승인했습니다.'
                  : props.rowData1?.gubun === '미해결'
                    ? '해결되지 않은 요청입니다.'
                    : props.rowData1?.gubun === '종료'
                      ? '작업이 종료되었습니다.'
                      : null}
              </span>
              <br />
              {props.rowData1?.gubun === '승인'
                ? '아래 사항들을 통해'
                : props.rowData1?.gubun === '미해결'
                  ? '수정을 통해 조치해주세요.'
                  : props.rowData1?.gubun === '종료'
                    ? ''
                    : null}
              <br />
              {props.rowData1?.gubun === '승인'
                ? '조치 내용을 알 수 있습니다.'
                : props.rowData1?.gubun === '미해결'
                  ? ''
                  : props.rowData1?.gubun === '종료'
                    ? ''
                    : null}
            </>
          )}
        </Box>

        {props.stopImageList && props.stopImageList.length > 0 ? (
          <Box sx={{ position: 'relative', my: 1 }}>
            <Swiper
              modules={[Pagination]}
              slidesPerView={1}
              nested={true}
              style={{
                width: '100%',
                height: '300px',
                borderRadius: '8px',
                border: '1px solid #DFD9D9',
              }}
              onSlideChange={(swiper) => setStopIndex(swiper.realIndex)}
            >
              {props.stopImageList.map((img, idx) => (
                <SwiperSlide key={idx}>
                  <PinchZoom
                    componentWrapperStyle={{ width: '100%', height: '100%' }}
                    componentContentStyle={{ width: '100%', height: '100%' }}
                    contents={
                      <Box
                        sx={{
                          width: '100%',
                          height: '300px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          src={`${Global.file.useUrl}files/${img}`}
                          alt={`stop-img-${idx}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      </Box>
                    }
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* 하단 인덱스 표시 */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 8,
                right: 12,
                background: 'rgba(0,0,0,0.6)',
                color: '#fff',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                zIndex: 10,
              }}
            >
              {stopIndex + 1} / {props.stopImageList.length}
            </Box>
          </Box>
        ) : (
          <Box sx={{ px: 1, my: 1 }}>
            <Box
              sx={{
                width: '100%',
                height: '200px',
                backgroundColor: '#f3f1f1ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px',
                px: 1,
              }}
            >
              <Icon.WorkInfoBaseImg width={50} height={40} />
            </Box>
          </Box>
        )}

        <Box sx={{ my: 1 }}>
          <Box
            component="p"
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#3A3A3A',
              marginBottom: '8px',
            }}
          >
            {getWriterRoleLabel(props.rowData1)}
          </Box>
          <WorkStopPersonInfo person={getWriterPerson(props.rowData1)} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontWeight: 'bold',
          }}
        >
          <Icon.Date width={22} />
          <p>{dayjs(props.rowData1.createDate).format('YYYY-MM-DD HH:mm')}</p>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: '#fafafaff',
            p: 1,
            borderRadius: 1,
            my: 1,
          }}
        >
          {props.rowData1?.stopComment}
        </Box>
        <WorkStopRecipientSection
          receivingDepartments={props.rowData1?.receivingDepartments}
          recipients={props.rowData1?.recipients}
        />
        {props.rowData1?.solveYn === 'Y' && (
          <Box
            sx={{
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <hr
              style={{
                border: 'none',
                borderTop: '2px solid #7c7777ff',
                margin: '4px 0',
              }}
            />
            <p
              style={{ fontSize: '20px', fontWeight: 'bold', color: '#3A3A3A' }}
            >
              조치사항{' '}
            </p>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <p>조치자 </p>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <p style={{ color: '#DD8B44' }}>
                  {props.rowData1?.solverName}{' '}
                </p>
                <p>{props.rowData1?.solverPosition} </p>
                <p>{props.rowData1?.solverDepNmLast} </p>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <p>조치일시 </p>
              <p style={{ color: '#DD8B44' }}>
                {dayjs(props.rowData1?.updateDate).format('YYYY-MM-DD HH:mm')}
              </p>
            </Box>
            <Box>
              {props.solveImageList && props.solveImageList.length > 0 && (
                <Box sx={{ position: 'relative', my: 1 }}>
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    nested={true}
                    style={{
                      width: '100%',
                      height: '300px',
                      borderRadius: '8px',
                      border: '1px solid #DFD9D9',
                    }}
                    onSlideChange={(swiper) => setSolveIndex(swiper.realIndex)}
                  >
                    {props.solveImageList.map((img, idx) => (
                      <SwiperSlide key={idx}>
                        <PinchZoom
                          componentWrapperStyle={{
                            width: '100%',
                            height: '100%',
                          }}
                          componentContentStyle={{
                            width: '100%',
                            height: '100%',
                          }}
                          contents={
                            <Box
                              sx={{
                                width: '100%',
                                height: '300px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                src={`${Global.file.useUrl}files/${img}`}
                                alt={`stop-img-${idx}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </Box>
                          }
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* 하단 인덱스 표시 */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 8,
                      right: 12,
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fff',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      zIndex: 10,
                    }}
                  >
                    {solveIndex + 1} / {props.solveImageList.length}
                  </Box>
                </Box>
              )}
              <p
                style={{
                  color: '#DD8B44',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  backgroundColor: '#fafafaff',
                  p: 1,
                  borderRadius: 1,
                  marginBottom: '1rem ',
                }}
              >
                {props.rowData1?.solveComment}
              </p>
            </Box>
          </Box>
        )}
      </Box>

      {/* 하단 버튼 */}
      {showButton && (
        <Box sx={{ mt: 1.5, mb: 2 }}>
          {gubun !== '승인' && gubun !== '미해결' && (
            <Button
              name="작업 중지 지시"
              sx={{
                width: '100%',
                height: 36,
                mb: 1,
                borderRadius: '5px',
                backgroundColor: '#fff',
                color: '#D14343',
                border: '1px solid #D14343',
                boxShadow:
                  '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
                '&:hover': {
                  backgroundColor: '#FDECEC',
                  color: '#B83838',
                  borderColor: '#B83838',
                },
              }}
              onClick={() => {
                const { workStopCd: _omit, ...prefillData } =
                  props.rowData1 ?? {};
                navigate('/M_WorkStop/write', {
                  state: {
                    fromInstruction: true,
                    data: prefillData,
                  },
                });
              }}
            />
          )}
          <PerButton
            saveText={saveText}
            saveDisabled={saveText === '작업 재개 승인' && !canResumeApprove}
            cancelText={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  width: '100%',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  opacity:
                    Commons.DecryptoAES(userInfo.userid) ===
                    props.rowData1?.createId
                      ? 0.5
                      : 1,
                }}
              >
                <Icon.PhoneFill />
                전화걸기
              </Box>
            }
            onCancel={(e) => {
              e.stopPropagation();
              if (
                Commons.DecryptoAES(userInfo.userid) !==
                props.rowData1?.createId
              ) {
                handleCall(props.rowData1.tel);
              } else {
                dispatch(
                  showSnackbar({
                    message: '자신이 작성한 건에는 전화할 수 없습니다.',
                    type: 'warning',
                  })
                );
              }
            }}
            onClick={() => {
              if (saveText === '작업 재개 승인' && !canResumeApprove) {
                dispatch(
                  showSnackbar({
                    message: '작업재개 승인 권한이 없습니다.',
                    type: 'warning',
                  })
                );
                return;
              }
              dispatch(
                BottomSheetActions.SetBottomSheetState({
                  bottom: true,
                  type: 'signWorkStop',
                })
              );
            }}
          />
        </Box>
      )}

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'signWorkStop' && (
        <SignWorkStopBottomStheet
          open={true}
          ToggleDrawer={ToggleDrawer}
          workStopUpload={props.workStopUpload}
          setWorkStopInputs={props.setWorkStopInputs}
          workStopInputs={props.workStopInputs}
          SaveLogic1={props.SaveLogic1}
          mode={saveText === '수정' ? 'edit' : 'approve'}
        />
      )}
    </Box>
  );
}
